import React from "react";
import {FormControlLabel, FormLabel, Radio, RadioGroup} from "@mui/material";
import {objects, strings} from "@atttomyx/shared-utils";
import {TYPE_ADMIN, TYPE_DEACON, TYPE_SECRETARY} from "../../constants";
import "./userTypeForm.css";

const UserTypeForm = (props) => {
    const { data, onChange : onSync } = props;

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);

        modified[field] = value;
        modified.valid = strings.isNotBlank(modified.type);

        onSync(modified);
    };

    return <div className="user-type-form">
        <div className="option top-margin">
            <FormLabel id="type">Type</FormLabel>
            <RadioGroup row={true} aria-labelledby="type"
                        onChange={(event) => onChange("type", event.target.value)}>
                <FormControlLabel
                    value={TYPE_ADMIN}
                    label={TYPE_ADMIN}
                    control={<Radio checked={data.type === TYPE_ADMIN} color="primary"/>}
                />
                <FormControlLabel
                    value={TYPE_DEACON}
                    label={TYPE_DEACON}
                    control={<Radio checked={data.type === TYPE_DEACON} color="primary"/>}
                />
                <FormControlLabel
                    value={TYPE_SECRETARY}
                    label={TYPE_SECRETARY}
                    control={<Radio checked={data.type === TYPE_SECRETARY} color="primary"/>}
                />
            </RadioGroup>
        </div>
    </div>
}

export default UserTypeForm;
